import TagRoundedIcon from '@mui/icons-material/TagRounded';
import { SectionCard, ui } from '../shared/insightUi';

const pillStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '7px 14px',
  borderRadius: 999,
  background: ui.primarySoft,
  color: ui.primary,
  fontSize: 13,
  fontWeight: 700,
  fontFamily: ui.font,
};

export default function TopHashTags({ top_hashtags = [] }) {
  const tags = (Array.isArray(top_hashtags) ? top_hashtags : []).slice(0, 12);
  if (!tags.length) return null;
  return (
    <SectionCard
      icon={<TagRoundedIcon fontSize="small" />}
      title="Top hashtags"
      subtitle="Most used hashtags on this profile"
    >
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
        {tags.map((hashtag, i) => (
          <span style={pillStyle} key={i}>
            #{hashtag.tag}
          </span>
        ))}
      </div>
    </SectionCard>
  );
}
